import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { SvgService } from '@markant-platform/shared/navigation/data-access';
import { BypassSecurityHtmlPipe } from '@markant-platform/shared/util-pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { NavigationItem } from '@markant-platform/shared/navigation/model';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'markant-platform-navigation-docker-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [BypassSecurityHtmlPipe, TranslocoPipe, AsyncPipe, MatTooltip],
})
export class NavigationItemComponent implements OnInit {
  @Input({ required: true }) navigationItem!: NavigationItem;

  @Output() clicked = new EventEmitter<void>();

  private readonly svgService = inject(SvgService);

  svg$: Observable<string> | undefined;

  ngOnInit(): void {
    this.svg$ = this.svgService.fetchSvg(`assets/images/navigation/${this.navigationItem.image}.svg`);
  }
}
